import React from 'react'
import {connect} from 'react-redux'
import {compose} from 'redux'
import {FormName} from 'redux-form'
import {resolve} from '@cred/shared/utils'

/* This HOC provides formData and the formName that can be used to trigger redux-form actions */

const mapStateToProps = formName => (state, props) => ({
    formData: props.formData || resolve(`form.${formName}`, state)
  }),
  withForm = WrappedComponent =>
    class WithForm extends React.Component {
      WrappedComponentWithForm = null

      render() {
        return (
          <FormName>
            {({form}) => {
              if (!this.WrappedComponentWithForm) {
                this.WrappedComponentWithForm = compose(
                  connect(mapStateToProps(form))
                )(WrappedComponent)
              }

              return <this.WrappedComponentWithForm {...this.props} formName={form}/>
            }}
          </FormName>
        )
      }
    }

export default withForm
